import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import tokens from '../theme/tokens';

// 가운데 글자가 있는 구분선 — 소셜 버튼과 이메일 로그인 사이 '또는'
const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    margin: '22px 0',
    color: tokens.placeholder,
    fontSize: 13,
    letterSpacing: -0.4,
    '&:before, &:after': {
      content: '""',
      flex: '1 1 auto',
      height: 1,
      backgroundColor: tokens.lineSoft,
    },
  },
  text: { padding: '0 12px' },
}));

function OrDivider({ children = '또는' }) {
  const cs = useStyles();
  return (
    <div className={cs.root} role="separator">
      <span className={cs.text}>{children}</span>
    </div>
  );
}

export default OrDivider;
